/* =====================================================================
   FILE: assets/pincode-guard.js
   ---------------------------------------------------------------------
   Scope: ONLY affects buttons tagged data-restricted="true".
   All other Add to Cart / Buy Now buttons on the site are untouched.

   Include once, sitewide, via layout/theme.liquid before </body>:
     <script src="{{ 'pincode-guard.js' | asset_url }}" data-pincode-url="{{ 'serviceable-pincodes.json' | asset_url }}" defer></script>
   ===================================================================== */

(function () {
  var STORAGE_KEY = 'pincode_verified';
  var PINCODE_JSON_URL = document.currentScript.dataset.pincodeUrl;
  var pincodeList = null;

  // ---- Inject styles once, site-wide ----
  var style = document.createElement('style');
  style.textContent =
    '[data-restricted][disabled] { opacity: 0.5; cursor: not-allowed; }' +
    '[data-restricted]:not([disabled]) { opacity: 1; cursor: pointer; }' +
    '.pincode-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.45); z-index: 9998; display: flex; align-items: center; justify-content: center; padding: 16px; }' +
    '.pincode-popover { position: relative; background: #fff; border-radius: 10px; padding: 24px; width: 100%; max-width: 340px; box-shadow: 0 10px 30px rgba(0,0,0,0.2); box-sizing: border-box; }' +
    '.pincode-popover-title { font-size: 17px; font-weight: 700; margin-bottom: 12px; }' +
    '.pincode-popover input { width: 100%; padding: 12px 14px; font-size: 16px; border: 1px solid #ccc; border-radius: 6px; margin-bottom: 12px; box-sizing: border-box; }' +
    '.pincode-popover-msg { margin-top: 10px; font-size: 14px; line-height: 1.4; }' +
    '.pincode-popover-close { position: absolute; top: 10px; right: 14px; background: none; border: none; font-size: 20px; line-height: 1; cursor: pointer; color: #666; }' +
    '@media (max-width: 749px) {' +
    '  .pincode-overlay { align-items: flex-end; padding: 0; }' +
    '  .pincode-popover { max-width: 100%; border-radius: 14px 14px 0 0; padding: 20px; }' +
    '}';
  document.head.appendChild(style);

  function loadPincodes(callback) {
    if (pincodeList) return callback(pincodeList);
    fetch(PINCODE_JSON_URL)
      .then(function (res) { return res.json(); })
      .then(function (data) { pincodeList = data; callback(pincodeList); })
      .catch(function () { callback([]); });
  }

  function getStored() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }

  function storeResult(code, valid) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ code: code, valid: valid }));
  }

  function setButtonState(btn, enabled) {
    btn.disabled = !enabled; // CSS handles the visual styling automatically now
    var hint = btn.parentElement ? btn.parentElement.querySelector('[data-pincode-hint]') : null;
    if (hint) hint.style.display = enabled ? 'none' : '';
  }

  function applyStoredStateToAll() {
    var stored = getStored();
    var buttons = document.querySelectorAll('[data-restricted="true"]');
    buttons.forEach(function (btn) {
      setButtonState(btn, !!(stored && stored.valid));
    });
  }

  var activeOverlay = null;

  function closePopover() {
    if (activeOverlay) { activeOverlay.remove(); activeOverlay = null; }
  }

  function openPopover() {
    closePopover();

    var overlay = document.createElement('div');
    overlay.className = 'pincode-overlay';

    var box = document.createElement('div');
    box.className = 'pincode-popover';
    box.innerHTML =
      '<button type="button" class="pincode-popover-close" aria-label="Close">&times;</button>' +
      '<div class="pincode-popover-title">Check delivery pincode</div>' +
      '<input type="text" maxlength="6" inputmode="numeric" placeholder="Enter 6-digit pincode">' +
      '<button type="button" class="button button--primary button--full-width">Check</button>' +
      '<div class="pincode-popover-msg"></div>';

    overlay.appendChild(box);
    document.body.appendChild(overlay);

    var input = box.querySelector('input');
    var checkBtn = box.querySelector('.button--primary');
    var closeBtn = box.querySelector('.pincode-popover-close');
    var msg = box.querySelector('.pincode-popover-msg');

    closeBtn.addEventListener('click', closePopover);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closePopover();
    });

    checkBtn.addEventListener('click', function () {
      var code = input.value.trim();
      if (!/^\d{6}$/.test(code)) {
        msg.textContent = 'Enter a valid 6-digit pincode.';
        msg.style.color = '#b00020';
        return;
      }
      loadPincodes(function (list) {
        var valid = list.indexOf(code) !== -1;
        storeResult(code, valid);
        if (valid) {
          msg.textContent = 'Deliverable -- you can add this to cart now.';
          msg.style.color = '#1a7f37';
          applyStoredStateToAll();
          setTimeout(closePopover, 900);
        } else {
          msg.textContent = 'Sorry, not deliverable to ' + code + ' for this item.';
          msg.style.color = '#b00020';
        }
      });
    });

    input.focus();
    activeOverlay = overlay;
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-restricted="true"], [data-pincode-hint]');
    if (trigger) {
      var stored = getStored();
      if (trigger.hasAttribute('data-restricted') && stored && stored.valid) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      openPopover();
      return;
    }
  }, true);

  document.addEventListener('DOMContentLoaded', applyStoredStateToAll);
})();